<template>
<v-card flat v-if="employeeData">
    <v-card-text>
        <v-container class="pa-0" fluid>
            <v-row align="center" justify="center">
                <v-col md="5">
                    <v-hover v-slot:default="{ hover }">
                        <v-card class="pa-2" :elevation="hover ? 12 : 2" shaped>
                            <v-card-title class="general-background">
                                {{ $t('pdr.reference.employee') }}
                            </v-card-title>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.fullname') }}:</b> </td>
                                            <td>{{ employeeData.user.firstName }} {{ employeeData.user.lastName }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.jobtitle') }}:</b> </td>
                                            <td>{{ employeeData.user.jobTitle }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.businessunit') }}:</b> </td>
                                            <td>{{ employeeData.user.businessUnit!= undefined?employeeData.user.businessUnit.label:'' }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.groupfunction') }}:</b> </td>
                                            <td>{{ employeeData.user.groupFunction!= undefined?employeeData.user.groupFunction.label:'' }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>

                        </v-card>
                    </v-hover>
                </v-col>
                <v-col md="5">
                    <v-hover v-slot:default="{ hover }">
                        <v-card class="pa-2" shaped :elevation="hover ? 12 : 2">
                            <v-card-title class="general-background">
                                {{ $t('pdr.reference.manager') }}
                            </v-card-title>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.slmanager') }}:</b> </td>
                                            <td>{{ employeeData.slmanager.firstName }} {{ employeeData.slmanager.lastName }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.dlmanager') }}</b> </td>
                                            <td>{{ printDLManager() }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.company') }}</b> </td>
                                            <td>{{ employeeData.user.company!= undefined?employeeData.user.company.label:'' }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.hrreferent') }} :</b> </td>
                                            <td>{{ printHRReferent() }}</td>
                                        </tr>

                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-col md="5">
                    <v-hover v-slot:default="{ hover }">
                        <v-card class="pa-2" shaped :elevation="hover ? 12 : 2">
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.dateinterview') }} :</b> </td>
                                            <td v-if="employeeData.reviewFirstPart">
                                                {{ employeeData.reviewFirstPart.dateInterview | simpleDate  }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-hover>

                </v-col>
                <v-col md="5">
                    <v-hover v-slot:default="{ hover }">
                        <v-card class="pa-2" shaped :elevation="hover ? 12 : 2">
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.statut1') }}</b> </td>
                                            <td v-if="employeeData.reviewFirstPart">{{ employeeData.reviewFirstPart.status.label  }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>{{ $t('pdr.reference.statut2') }}</b> </td>
                                            <td v-if="employeeData.reviewSecondPart">{{ employeeData.reviewSecondPart.status.label  }} </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
    <v-alert v-if="employeeData.user.managersComments" class="mr-3 mb-10 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
        {{ $t('pdr.reference.Commentsonmanagers') }}<v-card-text v-html="employeeData.user.managersComments"> </v-card-text>
    </v-alert>

</v-card>
</template>

<script>
export default {
    name: 'References',

    props: {
        employeeData: Object,
    },
    computed: {

    },
    methods: {
        printHRReferent: function () {
            var hrRefernentFullName = '';
            if (this.employeeData.user.company && this.employeeData.user.company.hrReferentDto) {
                if (this.employeeData.user.company.hrReferentDto.firstName) {
                    hrRefernentFullName += this.employeeData.user.company.hrReferentDto.firstName;
                }
                if (this.employeeData.user.company.hrReferentDto.lastName) {
                    hrRefernentFullName += ' ' + this.employeeData.user.company.hrReferentDto.lastName;
                }
            }
            return hrRefernentFullName;
        },
        printDLManager: function() {
            var dlManagerFullName = '';
            if (this.employeeData.dlmanager.firstName) {
                dlManagerFullName += this.employeeData.dlmanager.firstName;
            }
            if (this.employeeData.dlmanager.lastName) {
                dlManagerFullName += ' ' + this.employeeData.dlmanager.lastName;
            }
            return dlManagerFullName;
        }

    },
    filters: {
        simpleDate: function (value) {
            if (!value) return ''
            const [year, month, day] = value.split('-')
            return `${day}/${month}/${year}`
        }
    },
}
</script>

<style>

</style>
